export function getResponsibleRequestErrorMessage(error, action) {
  const status = error && error.response ? error.response.status : null
  const data = error && error.response ? error.response.data : null

  if (status === 403) {
    return `Você não tem permissão para ${action} responsáveis.`
  }

  if (status === 404) {
    return 'O cadastro de responsáveis não foi encontrado.'
  }

  if (data && typeof data.message === 'string' && data.message.length > 0) {
    return data.message
  }

  if (!error || !error.response) {
    return 'Não foi possível comunicar com o servidor. Verifique sua conexão e tente novamente.'
  }

  return error.message || 'Não foi possível concluir a operação. Tente novamente.'
}
